import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { cn } from '@/utils'

interface BottomActionBarProps {
  error?: string | null
  onCancel: () => void
  onUpload: () => void
  isUploading?: boolean
  isUploadDisabled?: boolean
}

export const BottomActionBar: React.FC<BottomActionBarProps> = ({
  error,
  onCancel,
  onUpload,
  isUploading = false,
  isUploadDisabled = false,
}) => {
  const { t } = useTranslation()

  return (
    <div className="flex-shrink-0 bg-white border-t border-b-0 border-solid border-x-0 border-gray-light-200 shadow-lg w-[calc(100%+4rem)] -mx-8 -mb-8">
      <div
        className={cn(
          'flex flex-row',
          error ? 'justify-between' : 'justify-end'
        )}
      >
        {error && (
          <div
            className="px-6 py-3 border-b border-gray-light-200"
            role="alert"
          >
            <p className="font-normal text-[14px] text-sm text-error-600">
              {error}
            </p>
          </div>
        )}

        <div className="flex justify-end gap-3 px-10 py-6">
          {!isUploading && (
            <Button
              variant="outlined"
              onClick={onCancel}
              disabled={isUploading}
            >
              {t('common.cancel')}
            </Button>
          )}
          <Button
            color="primary"
            variant={isUploading ? 'outlined' : 'solid'}
            onClick={isUploading ? onCancel : onUpload}
            disabled={isUploading ? false : isUploadDisabled}
            className={
              isUploading
                ? 'bg-white text-secondary-700 hover:bg-gray-light-100'
                : ''
            }
          >
            {isUploading ? t('common.close') : t('fileUpload.upload')}
          </Button>
        </div>
      </div>
    </div>
  )
}
